import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PreAuthList(){

  const [ipViewData, setIpViewData] = useState([]);
  const [insData, setinsData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedInsId, setSelectedInsId] = useState(null);
  const [estDate, setEstDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [preAmount, setPreAmount] = useState({
    "est_amount":'',
    "policyno":'',
    "cardno":'',
    "addedby":'',
    "status":'',
    "ip_add":'',
  });

  useEffect(() => {
    fetchIpViewData();
    fetchinsData();
  }, []);

  function fetchIpViewData() {
        const url = `${baseUrl}view-insur/?status=2&payment=Insurance`;
        axios.get(url)
          .then(response => {
            setIpViewData(response.data);
          })
          .catch(error => {
            console.log(error);
          });
  }
  function fetchinsData() {
        const url = `${baseUrl}pre-insur-create/`;
        axios.get(url)
          .then(response => {
            setinsData(response.data);
          })
          .catch(error => {
            console.log(error);
          });
  }
  const handleDateChange = (date) => {
  if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setSelectedDate(dateObj);
    }
    };
    const columns = [
        {field:'ip_id', headerName:'IP ID',
          renderCell: (params) => (
              <Link to={`/ip-pat-view/${params.row.id}/`}>
                {params.value}
              </Link>
          ),
          width: 100,
          },
        {field:'pat__pat_id', headerName:'Pat Id', width:40},
        {field:'pat__patient', headerName:'Patient', width:150},
        {field:'pat__age', headerName:'Age', width:10},
        {field:'pat__mobile', headerName:'Mobile', width:100},
        {field:'pat__address1', headerName:'Address', width:220},
        {field:'adhar', headerName:'Adhar', width:120},
        {field:'primary_consult__consultant', headerName:'Consultant', width:100},
        {field:'room_no__room_no', headerName:'Room No', width:75},
        {field:'payment', headerName:'Payment', width:100},
         { field: 'admit_date', headerName: 'Admitted On', width: 150,
    renderCell: (params) => (
      <span>{formatDateTime(params.value)}</span>
    ),
  },
        {
            field: 'action',
            headerName: 'Action',
            renderCell: (params) => {
              const matchingInsData = insData.filter((data) => data.ip.id === params.id);
              const sortedInsData = matchingInsData.sort((a, b) => b.id - a.id);
              const latestInsData = sortedInsData[0];

              if (matchingInsData.length > 0 && latestInsData.status === 1) {
                return (
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target="#due-app-modal"
                    onClick={() => handleInsClick(latestInsData.id)}
                  >
                    Approve
                  </button>
                );
              } else {
                return (
                  <button
                    type="button"
                    className="btn btn-warning"
                    data-bs-toggle="modal"
                    data-bs-target="#due-inv-modal"
                    onClick={() => handleClick(params.id)}
                  >
                    Pre Auth
                  </button>
                );
              }
            },
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
          },
      ];


      const handleClick = (id) => {
        setSelectedRowId(id); // Update the selected row ID when the button is clicked
      };
      const handleInsClick = (id) => {
        setSelectedInsId(id); // Update the selected row ID when the button is clicked
      };
        const handleSubmit = (event) => {
          event.preventDefault();
          const form = event.target;
          const estAmountInput = document.getElementById('est_amount');
          const est_amount = estAmountInput.value;
          const policynoInput = document.getElementById('policyno');
          const policyno = policynoInput.value;
          const cardnoInput = document.getElementById('cardno');
          const cardno = cardnoInput.value;
          const raise_date= estDate.toISOString().slice(0,10);
          const ip_id = selectedRowId;
            const _formData = new FormData();
            _formData.append('ip', ip_id);
            _formData.append('est_amount', est_amount);
            _formData.append('policyno', policyno);
            _formData.append('cardno', cardno);
            _formData.append('raise_date', raise_date);
            _formData.append('status', '1');
            _formData.append('addedby', userName);
            _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
            axios.post(baseUrl + 'pre-insur-create/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              if (response.status == 200 || response.status == 201) {
                  Swal.fire({
                    title: 'Pre Authorisation is Generated',
                    icon: 'success',
                    timer: 5000,
                    showConfirmButton: false
                  });
                  setTimeout(() => {
                    window.location.href = ('/preauth-list/');
                  }, 3000);
                }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
        };
        const handleInsSubmit = (event) => {
          event.preventDefault();
          const form = event.target;
          const appAmountInput = document.getElementById('app_amount');
          const app_amount = appAmountInput.value;
          const ccnInput = document.getElementById('ccn');
          const ccn = ccnInput.value;
          const reasonInput = document.getElementById('reason');
          const reason = reasonInput.value;
          const statusInput = document.getElementById('ins_status');
          const status = statusInput.value;
          const app_date= selectedDate.toISOString().slice(0,10);
          const id = selectedInsId;
            const _formData = new FormData();
            _formData.append('app_amount', app_amount);
            _formData.append('ccn', ccn);
            _formData.append('reason', reason);
            _formData.append('app_date', app_date);
            _formData.append('status', status);
            _formData.append('updatedby', userName);
            _formData.append('addedby', userName);
            _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
            axios.put(baseUrl + 'update-pre-insur/' + id +'/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              if (response.status == 200 || response.status == 201) {
                  Swal.fire({
                    title: 'Insurance Status Updated',
                    icon: 'success',
                    timer: 5000,
                    showConfirmButton: false
                  });
                  setTimeout(() => {
                    window.location.href = ('/preauth-list/');
                  }, 3000);
                }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
        };

    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Inpatient Insurance List
    </h3>
    {ipViewData.length > 0 ? (
        <div style={{ height: 500, width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {ipViewData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
        </div>
    ) : (
      <></>
    )}
    </div>
    <div className="modal fade" id="due-inv-modal" tabIndex="-1" aria-labelledby="due-inv-modal-label"
    aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="due-lab-modal-label">Pre Authorisation Request</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form>
              <label className="form-label">Estimated Amount</label>
              <input type="number" className="form-control" id="est_amount" name="est_amount"
                 required/>
                <label className="form-label">Policy No:</label>
                <input type="text" className="form-control" id="policyno" name="policyno"
                 required/>
                 <label className="form-label">Card No:</label>
                <input type="text" className="form-control" id="cardno" name="cardno"
                required/>
                <button type="button" onClick={handleSubmit} className="btn btn-primary mt-4">
                   Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className="modal fade" id="due-app-modal" tabIndex="-1" aria-labelledby="due-app-modal-label"
    aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="due-lab-modal-label">Approval List</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form>
              <label className="form-label">Approved Amount</label>
              <input type="number" className="form-control" id="app_amount" name="app_amount"
                 required/>
                <label className="form-label">CC No:</label>
                <input type="text" className="form-control" id="ccn" name="ccn"
                 required/>
                 <label className="form-label">Status:</label>
                 <select name="ins_status" id="ins_status" className="form-control">
                   <option value="3">Approved</option>
                   <option value="0">Rejected</option>
                </select>
                 <label className="form-label">Reason:</label>
                <input type="text" className="form-control" id="reason" name="reason"
                required/>
                 <label className="form-label">Approved Date:</label>
                <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" />
                <button type="button" onClick={handleInsSubmit} className="btn btn-primary mt-4">
                   Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    </section>
    )
}

export default PreAuthList;
